module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-components/customer-list/customer-list.component.scss
// module id = ./src/app/customer-components/customer-list/customer-list.component.scss
// module chunks = main